import React from "react";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import ThisDayContainer from "~/Containers/ThisDayContainer";
import Tile from "~/Components/Tile";

const Kba = window.dreamchimney && window.dreamchimney.kba;

const historyDate = () =>
  new Date().toLocaleDateString("en-US", { month: "long", day: "numeric" });

const ThisDayPage = () => {
  const dateLabel = historyDate();

  return (
    <div className="home-page-component">
      <Helmet>
        <title>This Day in History ({dateLabel}) | ____ of the Day | Dream Chimney</title>
        <link rel="canonical" href="https://www.dreamchimney.com/oftheday/thisday" />
      </Helmet>
      <div className="pageTitle">This day in history ({dateLabel})</div>
      <div className="home-component">
        <ThisDayContainer
          render={({ posts, loading, failure }) => {
            if (loading) {
              return (
                <div className="container-loading">
                  <Spinner animation="border" size="sm" /> Loading...
                </div>
              );
            }
            if (failure) {
              return <p style={{ color: "#fff" }}>Couldn’t load posts for this date. Try again soon.</p>;
            }
            if (!posts.length) {
              return (
                <p style={{ color: "#fff" }}>
                  Nothing was posted on {dateLabel} in past years. Check back tomorrow.
                </p>
              );
            }
            return (
              <Row noGutters className="minimalGutter">
                {posts.map((item) => (
                  <Col xl={4} lg={6} xs={12} key={item.id}>
                    <Tile archive showDate otd={item} />
                  </Col>
                ))}
              </Row>
            );
          }}
        />
        {Kba && (
          <div style={{ paddingTop: "30px" }}>
            <Kba />
          </div>
        )}
      </div>
    </div>
  );
};

export default ThisDayPage;
